<template>
  <div class="information">
    <el-radio-group v-model="activeName" size="small" @change="getListTable">
      <el-radio-button label="out">出库审核</el-radio-button>
      <el-radio-button label="operate">操作</el-radio-button>
      <el-radio-button label="smtPackageOut">速卖通组包出库</el-radio-button>
      <el-radio-button label="bigPackageManage">大包管理</el-radio-button>
      <el-radio-button label="smtBtgLsgl">速卖通半托管揽收管理</el-radio-button>
    </el-radio-group>

    <information-out
      v-if="activeName === 'out'"
      ref="out"
      :user-info="UserInfo"
      :form-screen-data="formScreenData"
    >
      <template slot="formScreen">
        <form-screen
          ref="cofirmFormScreen"
          form-type="cofirm"
          :form-data="formData"
          @formChange="getSonCompanyList"
          @confirm="formConfirm"
          @resetSonCompany="resetSonCompany"
        />
        <el-divider></el-divider>
      </template>
    </information-out>
    <template v-else-if="activeName === 'operate'">
      <el-form
        :model="formScreen"
        ref="formScreen"
        label-width="100px"
        style="overflow: hidden"
      >
        <el-col :span="6">
          <el-form-item label="分公司" prop="branchCompanyId">
            <el-select
              v-model="formScreen.branchCompanyId"
              filterable
              placeholder="请选择"
              @change="selectChange"
            >
              <el-option
                v-for="item in listBranch"
                :key="item.id"
                :label="item.companyFullName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="子公司" prop="companyId">
            <el-select
              v-model="formScreen.companyId"
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in listSon"
                :key="item.id"
                :label="item.companyFullName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="开始日期" prop="startTimeString">
            <el-date-picker
              v-model="formScreen.startTimeString"
              align="right"
              type="datetime"
              placeholder="选择开始日期"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="结束日期" prop="endTimeString">
            <el-date-picker
              v-model="formScreen.endTimeString"
              align="right"
              type="datetime"
              placeholder="选择结束日期"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12" :offset="12">
          <el-form-item prop="searchString">
            <el-input
              v-model.trim="formScreen.searchString"
              placeholder="请输入订单号/订单ID"
              style="width: 70%"
            ></el-input>
            <el-button type="primary" @click="searchForm">搜索</el-button>
            <el-button type="primary" @click="resetForm('formScreen')"
              >重置</el-button
            >
          </el-form-item>
        </el-col>
      </el-form>
      <!-- <el-divider></el-divider> -->
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        v-loading="loadingTable"
      >
        <el-table-column
          prop="orderId"
          width="240"
          label="订单号/订单ID"
          align="left"
        >
          <template slot-scope="scope">
            <div>订单号：{{ scope.row.amazonOrderId }}</div>
            <div>订单ID：{{ scope.row.orderId }}</div>
          </template>
        </el-table-column>
        <el-table-column label="产品信息">
          <template slot-scope="scope">
            <div
              class="details"
              v-for="item in scope.row.orderItems"
              :key="item.id"
            >
              <div class="details_left">
                <el-popover
                  trigger="hover"
                  placement="right"
                  prop="orderItems.imageUrl"
                >
                  <img :src="item.imageUrl" alt />
                  <div class="scope_img" slot="reference">
                    <img :src="item.imageUrl" alt />
                  </div>
                </el-popover>
              </div>
              <div class="details_right">
                <div style="width: 100%">
                  price: {{ item.itemAmount }}
                  {{ item.itemCurrencyCode }}
                </div>
                <div style="width: 100%">SKU: {{ item.sellerSKU }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="quantityOfOrdered"
          width="80"
          label="数量"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="channelResultTime"
          width="200"
          label="更新时间"
          align="center"
        ></el-table-column>
        <!-- <el-table-column prop="branchCompanyName" label="所属分公司" width="200" align="center"></el-table-column>
                <el-table-column prop="subCompanyName" label="所属子公司" width="200" align="center"></el-table-column> -->
        <el-table-column
          width="200"
          prop="ziName"
          label="所属公司"
          align="center"
        >
          <template slot-scope="scope">
            <div>
              <span>{{ scope.row.branchCompanyName }}</span>
              <span
                v-if="scope.row.branchCompanyName && scope.row.subCompanyName"
                >&nbsp;-&nbsp;</span
              >
              <span>{{ scope.row.subCompanyName }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="80" align="center">
          <template slot-scope="scope">
            <i
              class="el-icon-edit-outline fontSize-30"
              @click="edit(scope.row)"
            ></i>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
      <operationDepartment
        ref="operationDepartment"
        :bag-list="bagList"
        @confirm="operationDepartmentConfirm"
      />
    </template>

    <template v-else-if="activeName === 'smtPackageOut'">
      <smtPackageOutTb></smtPackageOutTb>
    </template>
    <template v-else-if="activeName === 'bigPackageManage'">
      <bigPackageManageTb></bigPackageManageTb>
    </template>
    <template v-else>
      <smtLsManageTb></smtLsManageTb>
    </template>
  </div>
</template>

<script>
import formScreen from "./InformationDepartment/formScreen1";
import operationDepartment from "./operationDepartment/operationDepartment";
import informationOut from "./InformationDepartment/informationOut";
import smtPackageOutTb from "./operationComponents/smtPackageOutTb.vue";
import bigPackageManageTb from "./operationComponents/bigPackageManageTb.vue";
import smtLsManageTb from "./operationComponents/smtLsManageTb.vue";
import { ajaxPost, Baseurl } from "@/api/api/api";

export default {
  name: "operation",
  components: {
    operationDepartment,
    informationOut,
    formScreen,
    smtPackageOutTb, //速卖通大包出库
    bigPackageManageTb, //大包管理
    smtLsManageTb, //速卖通半托揽收管理
  },
  data() {
    return {
      activeName: "out",
      headClass: this.common.headClass,
      formScreen: {
        branchCompanyId: "",
        companyId: "",
        startTimeString: "", //开始时间
        endTimeString: "", //结束时间
        searchString: "", //全字段搜索
      },
      formData: {
        listBranch: [],
        listSon: [],
        listChannel: [],
      },
      formScreenData: {},
      listSon: [],
      listBranch: [],
      tableData: [],
      Operatorlist: [],
      page: 1,
      size: 20,
      total: 0,
      UserInfo: {},
      bagList: [],
      loadingTable: false,
    };
  },
  created() {
    this.UserInfo = JSON.parse(localStorage.getItem("role"));
    this.getBagList();
    this.getBranchCompanyList();
    this.getListTable();
  },
  methods: {
    getBagList() {
      const API = Baseurl + "priceSettingController/getPriceSettingListByType";
      const paramsData = {
        priceType: "3",
        companyId: this.UserInfo.company_id,
      };
      ajaxPost(API, paramsData).then((res) => {
        const { code, data } = res.data;
        if (code === 200) {
          this.bagList = data;
        }
      });
    },
    getListTable() {
      if (this.activeName === "out") {
        this.$nextTick(() => {
          this.$refs.out.getTableData(true);
        });
      } else if (this.activeName === "operate") {
        this.getTableData();
      } else if (this.activeName === "smtPackageOut") {
        //速卖通组包出库
      } else if (this.activeName === "bigPackageManage") {
        //大包管理
      }
    },
    edit(row) {
      this.$refs.operationDepartment.init(row);
    },
    searchForm() {
      this.page = 1;
      this.getTableData();
    },
    resetForm(formName) {
      this.page = 1;
      this.$refs[formName].resetFields();
      this.formData.listSon = [];
      this.getTableData();
    },
    handleSizeChange(val) {
      this.size = val;
      this.getTableData();
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getTableData();
      console.log(`当前页: ${val}`);
    },
    getTableData() {
      const API = Baseurl + "logisticsController/getLogisticsOrderBaleList";
      const paramsData = {
        page: this.page,
        size: this.size,
        ...this.formScreen,
      };
      this.loadingTable = true;
      ajaxPost(API, paramsData).then((res) => {
        this.loadingTable = false;
        const { code, data } = res.data;
        if (code === 200) {
          this.tableData = data.list;
          this.total = data.total;
        }
      });
    },
    operationDepartmentConfirm(ids) {
      const API = Baseurl + "logisticsController/updateOrderCompleteStatus";
      const paramsData = {
        roleId: this.UserInfo.rid,
        ...ids,
      };
      ajaxPost(API, paramsData).then((res) => {
        const { code, data } = res.data;
        this.$refs.operationDepartment.isDoneBtnLoding = false;
        if (code === 200) {
          // this.tableData = data.list;
          // this.total = data.total;
          this.$refs.operationDepartment.close();
          this.getTableData();
        }
      });
    },
    selectChange(id) {
      this.getSonCompanyList(id);
    },
    getBranchCompanyList() {
      const API = Baseurl + "logisticsController/getAllBranchCompany";
      ajaxPost(API).then((res) => {
        const { code, data } = res.data;
        if (code === 200) {
          this.listBranch = data;
          this.formData.listBranch = data;
        }
      });
    },
    getSonCompanyList(id) {
      const API = Baseurl + "logisticsController/getAllSubCompanyById";
      const paramsData = { id };
      ajaxPost(API, paramsData).then((res) => {
        const { code, data } = res.data;
        if (code === 200) {
          this.listSon = data;
        }
      });
    },
    formConfirm(data) {
      this.formScreenData = data;
      // this.$refs.cofirmFormScreen.getTableData(true);
      this.$nextTick(() => {
        //     const option = this.$refs[this.activeName][0];
        //     option.getTableData(true);
        this.$refs.out.searchForm();
      });
    },
    resetSonCompany() {
      this.formData.listSon = [];
    },
    getSonCompanyList(id) {
      const API = Baseurl + "logisticsController/getAllSubCompanyById";
      const paramsData = { id };
      ajaxPost(API, paramsData).then((res) => {
        const { code, data } = res.data;
        if (code === 200) {
          this.formData.listSon = data;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.information {
  width: 98%;
  overflow: hidden;
  padding-bottom: 72px;
}
.scope_img {
  width: 55px;
  height: 55px;
  img {
    width: 100%;
    height: 100%;
  }
}
.prduct_img {
  width: 500px;
  height: 500px;
}
.cell {
  .scope_img {
    display: initial;
  }
  .scope_img img {
    width: 55px;
    height: 55px;
  }
}
.details {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.details_left {
  width: 30%;
  text-align: center;
}
.details_right {
  width: 70%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.pagination-container {
  width: 1660px;
  padding: 20px;
  position: fixed;
  right: 0;
  bottom: 0;
  background: #fff;
  z-index: 999;
  .el-pagination {
    display: flex;
    justify-content: center;
  }
}
</style>
